import React from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { useTheme } from '../theme/colors'

const Loader = () => {
    const theme = useTheme()
    return (
        <View
            style={[loaderStyles.viewContainer, { backgroundColor: theme.BACKGROUND }]}
        >
            <ActivityIndicator color={theme.ACCENT} size="large" />
        </View>
    )
}

export default Loader

const loaderStyles = StyleSheet.create({
    viewContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
})